import { isServiceUnavailableError } from '../services/api';

/**
 * In form catch blocks: show localized maintenance message instead of "Failed to fetch".
 * @returns {boolean} true if err was handled
 */
export function trySetServiceUnavailableError(err, setError, t) {
  if (isServiceUnavailableError(err)) {
    setError(t('errors.serviceUnavailableShort'));
    return true;
  }
  return false;
}
